// Path: src/Components/Booking/CancelBookingModal.jsx
import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import '../../../../../assets/css/user/general/stripepage/cancelbooking/Cancelbooking.css';


/**
 * Confirmation modal shown before a booking is cancelled.
 *
 * Props:
 *  - show:      boolean, controls visibility
 *  - onHide:    fn, called when the modal should close without cancelling
 *  - onConfirm: fn (may return a Promise), called when the user confirms cancellation
 *  - booking:   optional { equipmentName, date, time } to show a summary
 */
const CancelBooking = ({ show, onHide, onConfirm, booking }) => {
  const [isCancelling, setIsCancelling] = useState(false);

  const handleConfirm = async () => {
    try {
      setIsCancelling(true);
      await onConfirm?.();
    } finally {
      setIsCancelling(false);
    }
  }; 

  return (
    <Modal
      show={show}
      onHide={isCancelling ? undefined : onHide}
      centered
      backdrop={isCancelling ? 'static' : true}
      className="cbm-modal"
    >
      <Modal.Body className="cbm-body">

        <div className="cbm-icon-wrap">
          <svg viewBox="0 0 64 64" className="cbm-icon-svg" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="30" fill="#fef3e9"/>
            <circle cx="32" cy="32" r="30" fill="none" stroke="#fdb714" strokeWidth="2"/>
            <rect x="29" y="16" width="6" height="22" rx="3" fill="#e8590c"/>
            <circle cx="32" cy="45" r="3.5" fill="#e8590c"/>
          </svg>
        </div>

        <h2 className="cbm-title">Cancel This Booking?</h2>

        <p className="cbm-text">
          Are you sure you want to cancel your booking? This action
          cannot be undone.
        </p>

        {booking && (
          <div className="cbm-summary">
            {booking.equipmentName && (
              <div className="cbm-summary-row">
                <span className="cbm-summary-label">Equipment</span>
                <span className="cbm-summary-value">{booking.equipmentName}</span>
              </div>
            )}
            {booking.date && (
              <div className="cbm-summary-row">
                <span className="cbm-summary-label">Date</span>
                <span className="cbm-summary-value">{booking.date}</span>
              </div>
            )}
            {booking.time && (
              <div className="cbm-summary-row">
                <span className="cbm-summary-label">Time</span>
                <span className="cbm-summary-value">{booking.time}</span>
              </div>
            )}
          </div>
        )}

        <div className="cbm-btn-group">
          <Button className="cbm-keep-btn" onClick={onHide} disabled={isCancelling}>
            No, Keep Booking
          </Button>
          <Button className="cbm-cancel-btn" onClick={handleConfirm} disabled={isCancelling}>
            {isCancelling ? <span className="cbm-spinner" /> : 'Yes, Cancel Booking'}
          </Button>
        </div>

      </Modal.Body>
    </Modal>
  );
};

export default CancelBooking;